export const CompanyStatus = {
  PERSONAL: 'individual',
  REGISTERED: 'business-registered',
  NOTREGISTERED: 'business-not-registered'
};

export const CompanyStatuses = Object.values(CompanyStatus);
export const PersonalCompanyStatuses = [CompanyStatus.PERSONAL];
export const BusinessCompanyStatuses = [CompanyStatus.REGISTERED, CompanyStatus.NOTREGISTERED];

export type CompanyStatusType = (typeof CompanyStatus)[keyof typeof CompanyStatus];

export const CustomsKeys = {
  Address: {
    // Sender Specific
    TAXSTATUS: 'companyStatus',
    VATNUMBER: 'companyTaxNumber',
    TAXID: 'taxId',
    EORI: 'eori'
  },
  Content: {
    COMMODITYCODE: 'tariffCode',
    COUNTRYOFMANUFACTURE: 'countryOfManufacture'
  },
  Order: {
    // Generic
    EXPORTREASON: 'exportReason',
    IOSS: 'ioss',
    DUTYTERMS: 'dutyTerms'
  }
};

export const OrderCustomsFields = Object.values(CustomsKeys.Order);

export const ContentCustomsFields = Object.values(CustomsKeys.Content);

export const AddressCustomsFields = Object.values(CustomsKeys.Address);
export const AddressCustomsTaxFields = [
  CustomsKeys.Address.TAXID,
  CustomsKeys.Address.EORI,
  CustomsKeys.Address.VATNUMBER
];

export const AddressCustomsTaxFieldDefault = (key: string, name: string) => {
  switch (key) {
    case CustomsKeys.Address.EORI:
      return 'EORI';
    case CustomsKeys.Address.VATNUMBER:
      return '{{taxName}}';
    default:
      return name;
  }
};
